import {SelectSubMenuOptions} from "../SelectSubMenuOptions/SelectSubMenuOptions";
import type {ClusterCfgType, FilterSubMenuValue} from "../../types-analytics";
import FilterTools from "../FilterByParameters/FilterTools";

type featureAllowUserToSelectSubMenuOptionsCallbacks = {
    onChange: (newSelectedOption: string) => void;
}

export class featureAllowUserToSelectSubMenuOptions {

    private readonly subMenuConfig: {[key: string]: FilterSubMenuValue };
    private readonly clusterId: string;
    private cluster: FilterSubMenuValue;
    private readonly callbacks: featureAllowUserToSelectSubMenuOptionsCallbacks;
    
    constructor(
        root: HTMLDivElement,
        itemId: string,
        subMenuConfig: {[key: string]: FilterSubMenuValue },
        callbacks: featureAllowUserToSelectSubMenuOptionsCallbacks
    ) {
        this.subMenuConfig = subMenuConfig;
        this.clusterId = this.getClusterIdFromGivenItemId(itemId);
        this.cluster = this.subMenuConfig[this.clusterId];
        this.callbacks = callbacks;

        console.log('EEE, featureAllowUserToSelectSubMenuOptions', this.clusterId, this.cluster, this.subMenuConfig);
        
        if (this.clusterId!=='') {
            console.debug('featureAllowUserToSelectSubMenuOptions, item', itemId, this.getItemByItemId(itemId));
            new SelectSubMenuOptions(root, {
                cluster_name: this.cluster.label,
                name_db: itemId,
                cluster_cfg: this.getItemByItemId(itemId)!.params,
                cluster_params: this.cluster.cfg,
            }, {
                onChange: (cluster_cfg: ClusterCfgType) => {
                    let newFieldName = (new FilterTools()).getFieldNameWithGivenClusterCfg(this.subMenuConfig, cluster_cfg);
                    console.debug('SelectSubMenuOptions, onChange', cluster_cfg, newFieldName);
                    this.callbacks.onChange(newFieldName);
                }
            });
            root.style.display = 'flex';
        } else {
            console.info('featureAllowUserToSelectSubMenuOptions, clusterId not found', itemId);
            root.innerHTML = '';
            root.style.display = 'none';
        }
    }
    
    private getClusterIdFromGivenItemId(itemId: string): string {
        let output: string = '';
        Object.keys(this.subMenuConfig).forEach((clusterId: string) => {
            if (this.subMenuConfig[clusterId].items.map( item => item.id).includes(itemId)) {
                output = clusterId;
                return;
            }
        });
        return output;
    }
    
    private getItemByItemId(itemId: string) {
        let output: any;
        if (this.subMenuConfig) {
            Object.keys(this.subMenuConfig).forEach((clusterId: string) => {
                console.debug('getItemById, clusterId', clusterId);
                let item = this.subMenuConfig[clusterId]?.items.find(item => item.id === itemId);
                if (item) {
                    output = item;
                    return;
                }
            });
        }
        return output;
    }

}